import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleItem } from '../../api/models';
import { enumPaymentMethod } from '../models/enum-payment-method';

@Pipe({ name: 'paymentMethod' })
export class PaymentMethodPipe implements PipeTransform {
  transform(value: string, ...args: boolean[]): string {
    switch (value) {
      case enumPaymentMethod.STRIPE_ADVANCE:
        return `<div class="badge-container stripe_adv px-5"><small>Stripe</small></div>`;
      case enumPaymentMethod.STRIPE_TRANSFER:
        return `<div class="badge-container stripe_adv px-5"><small>Stripe</small></div>`;
      case enumPaymentMethod.BANK_TRANSFER_ADV:
        return `<div class="badge-container bank_trans px-5"><small>Bonifico</small></div>`;
      case enumPaymentMethod.BANK_TRANSFER_PAYOFF:
        return `<div class="badge-container bank_trans px-5"><small>Bonifico</small></div>`;
      case enumPaymentMethod.SCALAPAY_TRANSFER:
        return `<div class="badge-container scalapay_trans px-5"><small>Scalapay</small></div>`;
      case enumPaymentMethod.CASH_ADV:
        return `<div class="badge-container cash_trans px-5"><small>Contanti</small></div>`;
      case enumPaymentMethod.CASH_PAYOFF:
        return `<div class="badge-container cash_trans px-5"><small>Contanti</small></div>`;
    }
    return ``;
  }
}
